import { useCallback, useSyncExternalStore } from 'react'
import type { CookieConsentCategory } from '@App/common/types/cookie-consent'

const COOKIEBOT_CONSENT_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'] as const

const subscribeToCookiebotConsent = (onConsentChange: () => void) => {
    COOKIEBOT_CONSENT_EVENTS.forEach((eventName) => window.addEventListener(eventName, onConsentChange))

    return () => {
        COOKIEBOT_CONSENT_EVENTS.forEach((eventName) => window.removeEventListener(eventName, onConsentChange))
    }
}

const hasCookieConsent = (category: CookieConsentCategory) =>
    typeof Cookiebot !== 'undefined' && Boolean(Cookiebot.consent?.[category])

const getServerSnapshot = () => false

const useCookieConsent = (category: CookieConsentCategory): boolean => {
    const getSnapshot = useCallback(() => hasCookieConsent(category), [category])

    return useSyncExternalStore(subscribeToCookiebotConsent, getSnapshot, getServerSnapshot)
}

export default useCookieConsent
